import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material";

const NumberBadgeContainer = styled(Box)(
  () => ({
    display: "flex",
    alignItems: "center",
    gap: "16px",
  }));

const NumberStyledBadge = styled(Badge)(
  () => ({
    "& .MuiBadge-badge": {
      fontSize: "0.6rem",
      height: "16px",
      minWidth: "16px",
    },
  }));

type NumberBadgeProps = {
  tooltip?: string,
  text?: string,
  badgeCount?: number,
  color?: "error" | "warning" | "secondary" | "default" | "primary" | "success" | "info",
};

export default function NumberBadge(props: Readonly<NumberBadgeProps>) {
  const {
    tooltip,
    text,
    badgeCount,
    color,
  } = props;


  return (
    <NumberBadgeContainer>
      <span>{text}</span>
      <Tooltip title={tooltip} placement="bottom">
        <NumberBadgeContainer>
          <NumberStyledBadge 
            color={badgeCount ? (color ?? 'default') : 'default'} 
            badgeContent={badgeCount} 
            showZero={true} 
          />
        </NumberBadgeContainer>
      </Tooltip>
    </NumberBadgeContainer>
  );
}
